module.exports = __webpack_public_path__ + "4111ebb34c81b29705a6834ef04a44b9.svg";